import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance } from "vue";
import { calcularRankingAnual, type RankingAnual } from "@/utils/rankings";
import axios from "@/axios-auth";
import { getCategoriasConfig, getDeportesConfig } from "@/utils/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Rankings',
  setup(__props) {

const { proxy } = getCurrentInstance();

const añoSeleccionado = ref(new Date().getFullYear());
const categoriaSeleccionada = ref("");
const deporteSeleccionado = ref("");
const generoSeleccionado = ref("");
const cargando = ref(false);
const ranking = ref<RankingAnual | null>(null);

const modalDetalleVisible = ref(false);
const jugadorDetalle = ref<any>(null);

const añosDisponibles = ref<number[]>([]);

const headers = [
  { text: "Pos.", value: "posicion", sortable: false, width: "100" },
  { text: "Jugador", value: "nombreJugador", sortable: false },
  { text: "Puntos", value: "puntosTotal", sortable: true },
  { text: "Competencias", value: "competencias", sortable: false },
  { text: "Acciones", value: "acciones", sortable: false, align: "center" },
];

const tiposCompetencia = [
  { text: "Dobles", value: "Dobles" },
  { text: "Single", value: "Single" },
];

const generos = [
  { text: "Masculino", value: "Masculino" },
  { text: "Femenino", value: "Femenino" },
  { text: "Mixto", value: "Mixto" },
];

function getColorPosicion(posicion: number): string {
  if (posicion === 1) return "amber darken-1";
  if (posicion === 2) return "grey lighten-1";
  if (posicion === 3) return "orange darken-3";
  return "grey";
}

const deportes = ref([]);
const categorias = ref([]);

function calcularPromedioPuntos(jugador: any): number {
  if (!jugador.competencias.length) return 0;
  return Math.round(jugador.puntosTotal / jugador.competencias.length);
}

function verDetalleJugador(jugador: any) {
  jugadorDetalle.value = jugador;
  modalDetalleVisible.value = true;
}

async function cargarRanking() {
  if (!categoriaSeleccionada.value || !generoSeleccionado.value) {
    proxy.$swal({
      icon: "warning",
      title: "Faltan filtros",
      text: "Debe seleccionar categoría y género",
      timer: 3000,
    });
    return;
  }

  cargando.value = true;

  try {
    // Llamar al endpoint para obtener los rankings (ya filtrados en backend)
    const { data } = await axios.get("/Ranking/GetRankings", {
      params: {
        year: añoSeleccionado.value,
        deporte: deporteSeleccionado.value,
        categoria: categoriaSeleccionada.value,
        genero: generoSeleccionado.value,
        idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
      },
    });

    const rankings = data
      ? data.map((item: any) => {
          return {
            ...item,
            jugadores: JSON.parse(item.jugadores),
          };
        })
      : [];

    const jugadoresAplanados: any[] = [];

    rankings.forEach((competencia: any) => {
      competencia.jugadores.forEach((jugador: any) => {
        jugadoresAplanados.push({
          idJugador: jugador.idJugador,
          nombreJugador: jugador.nombreJugador,
          posicion: jugador.posicion,
          puntosAsignados: jugador.puntosAsignados,
          idCompetencia: competencia.idTorneo,
          tipoCompetencia: competencia.tipoCompetencia || "Torneo",
          nombreCompetencia:
            competencia.nombreCompetencia ||
            `Competencia ${competencia.idTorneo}`,
          categoria: competencia.categoria,
          genero: competencia.genero,
          fecha: competencia.fecha || new Date().toISOString(),
        });
      });
    });

    // Calcular el ranking con los datos pre-filtrados
    ranking.value = calcularRankingAnual(jugadoresAplanados);

    if (ranking.value.jugadores.length === 0) {
      proxy.$swal({
        icon: "info",
        title: "Sin resultados",
        text: "No hay datos de ranking para los filtros seleccionados",
        timer: 3000,
      });
    }
  } catch (error) {
    console.error("Error cargando ranking:", error);
    proxy.$swal({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar el ranking",
      timer: 3000,
    });
  } finally {
    cargando.value = false;
  }
}

function volver() {
  proxy.$router.push("/Home");
}

function cargarFiltrosDisponibles() {
  // Cargar años disponibles (últimos 5 años)
  const añoActual = new Date().getFullYear();
  añosDisponibles.value = Array.from({ length: 5 }, (_, i) => añoActual - i);
  categorias.value = getCategoriasConfig(
    proxy.$store.state.usuario.institucion.idInstitucion,
  ).categorias;
  deportes.value = getDeportesConfig(
    proxy.$store.state.usuario.institucion.idInstitucion,
  ).deportes.filter((deporte) => deporte.value !== "Futbol");
}

onMounted(() => {
  cargarFiltrosDisponibles();
});

return { __sfc: true,proxy, añoSeleccionado, categoriaSeleccionada, deporteSeleccionado, generoSeleccionado, cargando, ranking, modalDetalleVisible, jugadorDetalle, añosDisponibles, headers, tiposCompetencia, generos, getColorPosicion, deportes, categorias, calcularPromedioPuntos, verDetalleJugador, cargarRanking, volver, cargarFiltrosDisponibles }
}

})